export default __webpack_public_path__ + "static/media/404-hd.e044c5fa.png";